import type { FlagName, FlagOverrides } from './feature-flag-cache';
import {
  bootstrapFeatureFlagCache,
  clearOverridesFromCache,
  getCachedOverrideNames,
  getCachedOverrides,
  isFeatureEnabledFromCache,
  refreshOverrides,
  subscribeToOverrideChanges,
} from './feature-flag-cache';

export type { FlagName, FlagOverrides };

/**
 * Bootstraps the feature flag cache so overrides are resolved once during start-up.
 */
export const bootstrapFeatureFlags = () => {
  bootstrapFeatureFlagCache();
};

/**
 * Returns the list of flags that currently have overrides stored for the user.
 */
export const getStoredOverrideNames = () => getCachedOverrideNames();

/**
 * Resolves the effective flag value by applying user overrides on top of the defaults.
 * @param name
 */
export const isFeatureEnabled = (name: FlagName) => isFeatureEnabledFromCache(name);

/**
 * Clears all stored overrides for the active user and refreshes the cache.
 */
export const clearOverrides = () => {
  clearOverridesFromCache();
};

/**
 * Returns the full cached override map for inspection.
 */
export const getCachedFeatureOverrides = () => getCachedOverrides();

/**
 * Forces the cache to refresh regardless of detected changes.
 */
export const refreshFeatureOverrides = () => refreshOverrides();

/**
 * Subscribes to override change notifications.
 */
export const onFeatureOverridesChange = (listener: () => void) => subscribeToOverrideChanges(listener);
